"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
function StickyText({ text, selected, editing, className, onInput }, ref) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const containerRef = (0, react_1.useRef)();
    const [, dispatch] = (0, providers_1.useRichTextContext)();
    const touchEventsSupported = (0, ui_1.isTouchEventsSupported)();
    (0, react_1.useEffect)(() => {
        const onChange = () => {
            dispatch((0, hooks_1.updateTextStyles)());
        };
        document.addEventListener('selectionchange', onChange);
        return () => {
            document.removeEventListener('selectionchange', onChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setRef = (newRef) => {
        if (ref) {
            const tempRef = ref;
            tempRef.current = newRef;
        }
        if (containerRef) {
            containerRef.current = newRef;
        }
    };
    return ((0, jsx_runtime_1.jsx)(Container, { ref: setRef, className: className, contentEditable: editing, 
        // @ts-ignore
        placeholder: editing ? '' : t(i18n_1.Strings.tools.textbox.placeholder), placeholderNotActive: selected
            ? t(i18n_1.Strings.tools.textbox.placeholder)
            : touchEventsSupported
                ? t(i18n_1.Strings.tools.textbox.placeholderNotActiveTouch)
                : t(i18n_1.Strings.tools.textbox.placeholderNotActive), dangerouslySetInnerHTML: { __html: text }, onInput: onInput, "data-e2e": 'StickyText_Container' }));
}
exports.default = (0, react_1.forwardRef)(StickyText);
const Container = styled_components_1.default.div `
  flex-shrink: 0;

  width: 100%;

  color: ${({ theme }) => theme.text};

  font-size: 16px;

  word-wrap: break-word;

  outline: none;

  user-select: text;

  &:empty::before {
    color: ${({ theme }) => theme.textPlaceholder};

    content: attr(placeholder);
  }

  &:empty:not(:focus)::before {
    color: ${({ theme }) => theme.textPlaceholder};

    content: '${({ placeholderNotActive }) => placeholderNotActive}';
  }

  font[size='4'] {
    font-size: 2vmin !important;
    line-height: 2.5vmin;
  }

  font[size='3'] {
    font-size: 2vmin !important;
    line-height: 2.5vmin;
  }

  font[size='5'] {
    font-size: 2.4vh !important;
    line-height: 3vh;
  }

  font[size='6'] {
    font-size: 2.8vh !important;
    line-height: 3.5vh;
  }
`;
